// apps/web/src/components/parent/ApprovalTimeline.tsx
// Shows a simple event timeline for a checklist item.

import type { ChecklistItem } from '@homework-app/shared';

interface Props {
  item: ChecklistItem;
}

function formatTime(timestamp: string | null): string {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function ApprovalTimeline({ item }: Props) {
  const events: Array<{ label: string; time: string; color?: string }> = [];

  if (item.created_at) {
    events.push({ label: 'Created', time: formatTime(item.created_at) });
  }
  if (item.started_at) {
    events.push({ label: 'Started', time: formatTime(item.started_at), color: '#3b82f6' });
  }
  if (item.submitted_at) {
    events.push({ label: 'Submitted', time: formatTime(item.submitted_at), color: '#8b5cf6' });
  }
  if (item.verification) {
    events.push({
      label: item.verification.passed ? 'AI Passed' : 'AI Failed',
      time: formatTime(item.verification.created_at),
      color: item.verification.passed ? '#10b981' : '#ef4444'
    });
  }
  if (item.approved_at) {
    events.push({ label: 'Approved', time: formatTime(item.approved_at), color: '#10b981' });
  }

  if (events.length <= 1) return null;

  return (
    <div style={{
      display: 'flex',
      gap: '0.5rem',
      flexWrap: 'wrap',
      padding: '0.5rem 0',
      fontSize: '0.75rem',
      color: '#6b7280'
    }}>
      {events.map((event, idx) => (
        <span key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
          {idx > 0 && <span style={{ color: '#374151' }}>→</span>}
          <span style={{ color: event.color || '#9ca3af' }}>{event.label}</span>
          {event.time && <span style={{ color: '#6b7280' }}>{event.time}</span>}
        </span>
      ))}
    </div>
  );
}
